import React, { useState, useEffect, useRef } from "react";
//import "rsuite/dist/rsuite.min.css";
import { Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import check from "../../../picture/check.png";
import "./Styles.css";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import DataAccessories from "../../../file/data-accessories.json";
import "./autocom.css";
import Static_modal from "../etc/Static_modal";
import { useLanguage } from "../../../Language/LanguageContext";
function RegisDrone() {
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  let Navigate = useNavigate();
  function editdrone() {
    //setDisabless(false);
    Navigate("/profile/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }

  const form1 = useRef();
  const [checkuserdata, setcheckuserdata] = useState(false);
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState("");
  const [show, setShow] = useState(false);
  const [saveupdate, setSaveupdate] = useState(false);
  const [senddata, setSenddata] = useState(false);
  const [showError, setShowError] = useState(false);
  const [ErrorData, setErrorData] = useState();
  const [updatedata, setUpdatedata] = useState(false);
  const [updatedatasuc, setUpdatedatasuc] = useState(false);
  const [purposename, setPurposename] = useState([null]);
  const [purpose_etc, setPurposeEtc] = useState(null);
  const [docsave, setDocsave] = useState(false);
  const [showSpin, setShowSpin] = useState(false);
  const [weight, setWeight] = useState(0);
  const [stdRemoteID, setStdRemoteID] = useState(true);
  const [frequency, setFrequency] = useState({
    checkbox1: 1,
    checkbox2: 0,
    checkbox3: 0,
    checkbox4: 0,
  });
  const [purpose, setPurpose] = useState({
    checkbox1: 1,
    checkbox2: 0,
    checkbox3: 0,
    checkbox4: 0,
    checkbox5: 0,
    checkbox6: 0,
    checkbox7: 0,
    checkbox8: 0,
    checkbox9: 0,
    checkbox10: 0,
    checkbox11: 0,
    checkbox12: 0,
    checkbox13: 0,
  });
  const [openpurpose, setOpenpurpose] = useState({
    open1: 0,
    open2: 0,
    open3: 0,
  });
  //const [lic_request, setLic_request] = useState();
  const [lic_req_data, setLic_req_data] = useState("");
  const [lic_req_data1, setLic_req_data1] = useState("");
  const [lic_req_data2, setLic_req_data2] = useState("");
  const [remote_sn, setRemote_sn] = useState("");
  const [remote_brand, setRemote_brand] = useState("");
  const [ins_type, setIns_type] = useState(
    "กรมธรรม์ภัยความรับผิดตามกฎหมายต่อบุคคลภายนอก"
  );
  const [ins_number, setIns_number] = useState("");
  const [ins_company_name, setIns_company_name] = useState("");
  const [ins_limit, setIns_limit] = useState(0);
  const [ins_limit_dummy, setIns_limit_dummy] = useState();
  const [ins_start, setIns_start] = useState("");
  const [ins_end, setIns_end] = useState("");
  const [model, setModel] = useState(""); ///mockup
  const [drone_sn, setDroneserial] = useState(""); ///mockup
  const [brand, setBrand] = useState(""); ///mockup
  const [disabless, setDisabless] = useState(true);
  const [chooselicense, setChooselicense] = useState("1");
  const [alllicreqdata, setAlllicreqdata] = useState();

  const [errorField, setErrorField] = useState(null);
  const [checkisu, setCheckisu] = useState(true);
  const [formType, setFormType] = useState(1);
  const [files, setFiles] = useState({
    idcard_file: null,
    homeregis_file: null,
    dronepic_file: null,
    droneserial_file: null,
    remoteserial_file: null,
    selfcert_file: null,
    aircraft_insu_file: null,
    attorney_doc_file: null,
    idcard_attorneyauth_file: null,
    idcard_attorney_file: null,
    legal_result_file: null,
  });
  const [previews, setPreviews] = useState({
    idcard_file: null,
    homeregis_file: null,
    dronepic_file: null,
    droneserial_file: null,
    remoteserial_file: null,
    selfcert_file: null,
    aircraft_insu_file: null,
    attorney_doc_file: null,
    idcard_attorneyauth_file: null,
    idcard_attorney_file: null,
    legal_result_file: null,
  });
  const [dataAccessories, setDataAccessories] = useState(DataAccessories);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const getpurpost = () => {
    const check = AuthServiceV2.DronePurposes();
    if (check != null) {
      check
        .then((res) => {
          setPurposename(res.data.data);
          console.log(res.data.data);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  useEffect(() => {
    getpurpost();
  }, []);
  const handleOptionChange = (event) => {
    setChooselicense(event.target.value);
    setLic_req_data("");
    setLic_req_data1("");
    setLic_req_data2("");
    console.log(event.target.value);
  };

  const handleClose = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    setUpdatedatasuc(false);
    setcheckuserdata(false);
    Navigate("/user/drone/statusDrone");
  };
  function handleFiles(event) {
    // console.log(event.target);
    const { id, files } = event.target;
    if (event.target.files[0]) {
      const maxSize = 2 * 1024 * 1024; // 2MB

      if (event.target.files[0].size > maxSize) {
        alert("ไฟล์ต้องมีขนาดไม่เกิน 2MB");
        event.target.value = "";
        return;
      }
    }
    if (files.length > 0) {
      const file = files[0];
      console.log(file);
      const reader = new FileReader();

      reader.onloadend = () => {
        setPreviews((prevPreviews) => ({
          ...prevPreviews,
          [id]: reader.result, // FileReader result is a data URL
        }));
      };

      reader.readAsDataURL(file);

      setFiles((prevFiles) => ({
        ...prevFiles,
        [id]: file,
      }));
    } else {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [id]: null,
      }));
      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        [id]: null,
      }));
    }
  }
  const [lastupdate, setLastupdate] = useState(false);
  const validatePattern = /^[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ./_-]{0,51}$/;
  const numberPattern = /^[0-9]{0,20}$/;

  const handleSend = (e) => {
    e.preventDefault();
    setErrorField(null);

    ////// Validated page 1 ////////

    if (drone_sn != undefined) {
    }
    if (
      !drone_sn.trim() === true ||
      validatePattern.test(drone_sn.trim()) === false
    ) {
      console.log("Test valid pattern");
      setFormType(1);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 200, "smooth");
    } else if (
      !brand.trim() === true ||
      validatePattern.test(brand.trim()) === false
    ) {
      setFormType(1);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 200, "smooth");
    } else if (
      !model.trim() === true ||
      validatePattern.test(model.trim()) === false
    ) {
      setFormType(1);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 200, "smooth");
    } else if (
      !remote_brand.trim() === true ||
      validatePattern.test(remote_brand.trim()) === false
    ) {
      setFormType(1);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 270, "smooth");
    } else if (
      !remote_sn.trim() === true ||
      validatePattern.test(remote_sn.trim()) === false
    ) {
      setFormType(1);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 270, "smooth");
      console.log("5");
    } else if (
      chooselicense === "1" &&
      (!lic_req_data.trim() ||
        !lic_req_data1.trim() ||
        validatePattern.test(lic_req_data.trim()) === false)
    ) {
      setFormType(1);
      setLastupdate(false);
      window.scrollTo(0, 270, "smooth");
    } else if (
      chooselicense === "2" &&
      (!lic_req_data.trim() ||
        !lic_req_data1.trim() ||
        validatePattern.test(lic_req_data.trim()) === false)
    ) {
      setFormType(1);
      setLastupdate(false);
      window.scrollTo(0, 270, "smooth");
    } else if (
      chooselicense == "3" &&
      (!lic_req_data.trim() ||
        !lic_req_data1.trim() ||
        numberPattern.test(lic_req_data1.trim()) === false)
    ) {
      setFormType(1);
      setLastupdate(false);
      window.scrollTo(0, 270, "smooth");
    } else if (
      chooselicense === "5" &&
      (!lic_req_data.trim() ||
        !lic_req_data1.trim() ||
        !lic_req_data2.trim() ||
        numberPattern.test(lic_req_data.trim()) === false)
    ) {
      setFormType(1);
      setLastupdate(false);
      window.scrollTo(0, 270, "smooth");
    }

    ////// Validated page 2 /////////
    else if (!ins_type.trim()) {
      setFormType(2);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 270, "smooth");
    } else if (
      (!ins_number.trim() === true ||
        validatePattern.test(ins_number.trim()) === false) &&
      weight > 2 &&
      weight < 25
    ) {
      console.log("f1");
      setFormType(2);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 270, "smooth");
    } else if (!ins_company_name.trim() && weight > 2 && weight < 25) {
      console.log("f2");
      setFormType(2);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 270, "smooth");
    } else if (
      (!ins_limit === true ||
        new RegExp(`^[0-9]{7,12}$`).test(ins_limit) === false) &&
      weight > 2 &&
      weight < 25
    ) {
      console.log("f3");
      setFormType(2);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 270, "smooth");
    } else if (!ins_start.trim() && weight > 2 && weight < 25) {
      console.log("f4");
      setFormType(2);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 270, "smooth");
    } else if (!ins_end.trim() && weight > 2 && weight < 25) {
      console.log("f5");
      setFormType(2);
      setLastupdate(false);
      setShow(false);
      window.scrollTo(0, 270, "smooth");
    }
    /////// Validated page 3 ///////
    ////// Validated page 4 ///////
    else if (!files.idcard_file) {
      setFormType(4);
      setLastupdate(false);
      window.scrollTo(0, 270, "smooth");
    } else if (!files.homeregis_file) {
      console.log("failer");
      setFormType(4);
      setLastupdate(false);
      window.scrollTo(0, 260, "smooth");
    } else if (!files.dronepic_file) {
      setFormType(4);
      setLastupdate(false);
      window.scrollTo(0, 250, "smooth");
    } else if (!files.droneserial_file) {
      setFormType(4);
      setLastupdate(false);
      window.scrollTo(0, 240, "smooth");
    } else if (!files.remoteserial_file) {
      setFormType(4);
      setLastupdate(false);
      window.scrollTo(0, 230, "smooth");
    } else if (!files.selfcert_file) {
      setFormType(4);
      setLastupdate(false);
      window.scrollTo(0, 220, "smooth");
    } else if (!files.aircraft_insu_file && checkisu === false) {
     
        setFormType(4);
      setLastupdate(false);
      window.scrollTo(0, 210, "smooth");
      
      
    } else {
      if (
        form1.current.checkValidity() === true &&
        lastupdate === true &&
        formType === 4
      ) {
        e.preventDefault();
        setShow(true);
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    setValidated(true);
    if (parseInt(chooselicense) === 4) {
    } else {
      if (parseInt(chooselicense) === 5) {
        setAlllicreqdata([lic_req_data, lic_req_data1, lic_req_data2]);
      } else {
        setAlllicreqdata([lic_req_data, lic_req_data1]);
      }
    }
  };
  useEffect(() => {
    let isValid = true;
    if (purpose.checkbox1 !== 1) {
    }

    for (let key in purpose) {
      if (key !== "checkbox1" && purpose[key] !== 0) {
        isValid = false;
        break;
      }
    }
    setCheckisu(isValid);
  }, [purpose]);
  const handleSendsuc = async (save) => {
    //await handlecommitdata(save);
    setShowSpin(true);
    setDocsave(save);
    setShow(false);

    //setSenddata(true);
    await register(save);
  };
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const value = checked ? 1 : 0;
    setFrequency((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: value,
    }));
  };
  const handleCheckboxpurposeChange = (event) => {
    const { name, checked } = event.target;
    const value = checked ? 1 : 0;
    setPurpose((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: value,
    }));
    console.log(purpose);
  };

  const handleUpdatesuc = (e) => {
    e.preventDefault();
    setUpdatedata(false);
    setUpdatedatasuc(true);
    setDocsave(true);
    //register(true);
  };
  const next = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    Navigate("/user/drone/statusDrone");
  };

  const register = (doc_save) => {
    const lastpurpose = [];
    const allfrequency = [
      frequency.checkbox1,
      frequency.checkbox2,
      frequency.checkbox3,
      frequency.checkbox4,
    ];

    const allpurpose = [
      purpose.checkbox1,
      purpose.checkbox2,
      purpose.checkbox3,
      purpose.checkbox4,
      purpose.checkbox5,
      purpose.checkbox6,
      purpose.checkbox7,
      purpose.checkbox8,
      purpose.checkbox9,
      purpose.checkbox10,
      purpose.checkbox11,
      purpose.checkbox12,
      purpose.checkbox13,
    ];
    for (let i = 0; i <= allpurpose.length; i++) {
      if (allpurpose[i] === 1) {
        lastpurpose.push(i + 1);
      }
    }
    const nonEmptyValues = inputFields
      .filter((field) => field.value !== "")
      .map((field) => field.value);
    const install_eq1 = nonEmptyValues.join(", ");
    // const DatawaitSend = useState({
    //   droneserial,
    //   brand,
    //   model,
    //   install_eq1,
    //   remote_sn,
    //   remote_brand,
    //   stdRemoteID,
    //   weight,
    //   allfrequency,
    //   lastpurpose,
    //   parseInt(chooselicense),
    //   alllicreqdata,
    //   ins_type,
    //   ins_number,
    //   ins_company_name,
    //   ins_limit,
    //   ins_start,
    //   ins_end,
    //   doc_save})
    const formData = new FormData();
    console.log(typeof parseFloat(weight));
    console.log(parseFloat(weight));
    // Append form fields from `Data` state
    if (doc_save === true) {
      for (const [key, value] of Object.entries({
        drone_sn: drone_sn ? drone_sn : null,
        brand: brand ? brand : null,
        model: model ? model : null,
        install_eq: install_eq1 ? install_eq1 : null,
        remote_sn: remote_sn ? remote_sn : null,
        remote_brand: remote_brand ? remote_brand : null,
        built_in_rid: stdRemoteID === true ? 0 : 1,
        weight: parseFloat(weight).toFixed(5),
        frequency: allfrequency,
        purpose: lastpurpose,
        purpose_etc: purpose_etc ? purpose_etc : null,
        lic_request: parseInt(chooselicense),
        lic_req_data: alllicreqdata ? alllicreqdata : null,
        ins_type: ins_type,
        ins_number: ins_number ? ins_number : null,
        ins_company_name: ins_company_name ? ins_company_name : null,
        ins_limit: ins_limit ? ins_limit : null,
        ins_start: ins_start ? ins_start : null,
        ins_end: ins_end ? ins_end : null,
        doc_save: doc_save === true ? 1 : 0,
      })) {
        if (Array.isArray(value)) {
          console.log(value);
          if (value === null) {
            formData.append(key, null);
          } else {
            formData.append(key, JSON.stringify(value));
          } // Convert arrays to JSON strings
        } else {
          formData.append(key, value);
        }
      }
    } else {
      for (const [key, value] of Object.entries({
        drone_sn: drone_sn,
        brand: brand,
        model: model,
        install_eq: install_eq1,
        remote_sn: remote_sn,
        remote_brand: remote_brand,
        built_in_rid: stdRemoteID === true ? 0 : 1,
        weight: parseFloat(weight).toFixed(5),
        frequency: allfrequency,
        purpose: lastpurpose,
        purpose_etc: purpose_etc,
        lic_request: parseInt(chooselicense),
        lic_req_data: alllicreqdata,
        ins_type: ins_type,
        ins_number: ins_number,
        ins_company_name: ins_company_name,
        ins_limit: ins_limit,
        ins_start: ins_start,
        ins_end: ins_end,
        doc_save: doc_save === true ? 1 : 0,
      })) {
        if (Array.isArray(value)) {
          console.log(value);
          if (value === null) {
            console.log(value);
            formData.append(key, null);
          } else {
            formData.append(key, JSON.stringify(value));
          } // Convert arrays to JSON strings
        } else {
          formData.append(key, value);
        }
      }
    }

    // Append files
    for (const [key, file] of Object.entries(files)) {
      if (file) {
        formData.append(key, file);
      }
    }

    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}: [File] ${value.name}`);
      } else {
        console.log(`${key}: ${value}`);
      }
    }
    // const install_eq1 = nonEmptyValues.join(", ");
    if (doc_save === true) {
      if (sessionStorage.getItem("type_user") === "corporation") {
        AuthServiceV2.registerdronecorp(formData)
          .then((Response) => {
            console.log(Response);
            setShowSpin(false);
            setSenddata(true);
            //Navigate("/statusDrone");
          })
          .catch((error) => {
            setShowSpin(false);
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });

            console.log(error.response.data.error_description);
            if (error.response.data.error_description) {
              setErrorData(error.response.data.error_description);
              setShowError(true);
            }
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          });
      } else {
        AuthServiceV2.registerdrone(formData)
          .then((Response) => {
            setShowSpin(false);
            console.log(Response);
            setSenddata(true);
            //Navigate("/statusDrone");
          })
          .catch((error) => {
            setShowSpin(false);
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });

            // if (error.response.data.error_description) {
            //   setErrorData(error.response.data.error_description);
            //   setShowError(true);
            // }
            // const resMessage =
            //   (error.response &&
            //     error.response.data &&
            //     error.response.data.message) ||
            //   error.message ||
            //   error.toString();
          });
      }
    } else {
      if (sessionStorage.getItem("type_user") === "corporation") {
        AuthServiceV2.registerdronecorp(formData)
          .then((Response) => {
            setShowSpin(false);
            console.log(Response);
            setSenddata(true);
            //Navigate("/statusDrone");
          })
          .catch((error) => {
            setShowSpin(false);
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });

            if (error.response.data.error_description) {
              setErrorData(error.response.data.error_description);
              setShowError(true);
            }
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          });
      } else {
        console.log(typeof formData.get("frequency"));
        AuthServiceV2.registerdrone(formData)
          .then(
            (Response) => {
              setShowSpin(false);
              console.log(Response);
              setSenddata(true);
              //Navigate("/statusDrone");
            },
            (error) => {}
          )
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
            setShowSpin(false);
            if (error.response.data.error_description) {
              setErrorData(error.response.data.error_description);
              setShowError(true);
            }
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          });
      }
    }
  };
  useEffect(() => {
    if (sessionStorage.getItem("type_user") === "corporation") {
      const check = AuthServiceV2.corporationdata();
      //console.log(check);
      if (check != null)
        check.then(function (result) {
          //console.log(result.data);
          if (result.data.data.cur_address != null) {
            console.log("passPIS");

            const data1 = AuthServiceV2.corporationdata()
              .then(function (result) {
                setData(result.data.data);
                console.log(result);
              })
              .catch((error) => {
                setTextBody(error);
                setModalToggle({ ...modalToggle, modalErr: true });
              });
          } else {
            console.log("passGDSNS");
            setcheckuserdata(true);
            setTimeout((e) => {
              setcheckuserdata(false);
              editdrone();
              //Navigate("/profile/editprofileuser");
            }, 3000);

            const data1 = AuthServiceV2.corporationdata()
              .then(function (result) {
                setData(result.data.data);
                //console.log(result)
              })
              .catch((error) => {
                setTextBody(error);
                setModalToggle({ ...modalToggle, modalErr: true });
              });
          }
          console.log(chooselicense);
        });
    } else {
      const check = AuthServiceV2.getCurrentUser();
      //console.log(check);
      if (check != null)
        check
          .then(function (result) {
            //console.log(result);
            if (result.data.data.address != null) {
              //console.log("passPIS");

              const data1 = AuthServiceV2.getCurrentUser()
                .then(function (result) {
                  setData(result.data.data);
                  //console.log(result);
                })
                .catch((error) => {
                  setTextBody(error);
                  setModalToggle({ ...modalToggle, modalErr: true });
                });
            } else {
              console.log("passGDSNS");
              setcheckuserdata(true);
              setTimeout((e) => {
                setcheckuserdata(false);
                editdrone();
                //Navigate("/profile/editprofileuser");
              }, 3000);

              const data1 = AuthServiceV2.getCurrentUser()
                .then(function (result) {
                  setData(result.data.data);
                  //console.log(result)
                })
                .catch((error) => {
                  setTextBody(error);
                  setModalToggle({ ...modalToggle, modalErr: true });
                });
            }
            //console.log(chooselicense);
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
          });
    }
  }, []);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    console.log(form);
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    event.preventDefault();
    setValidated(true);
  };

  //Dropdown content installed accessories
  const [inputFields, setInputFields] = useState([{ id: 1, value: "" }]);
  const [addfield, setAddfield] = useState(false);

  const handleInputChange = (num_id, inputvalue) => {
    console.log(num_id, inputvalue);
    const updatedFields = inputFields.map((field) =>
      field.id === num_id ? { ...field, value: inputvalue } : field
    );

    //console.log(dataAccessories);
    // const updateAccessories = dataAccessories.filter(
    //   (field) => field.id !== inputvalue
    // );
    // console.log( inputFields);
    // console.log(updateAccessories , dataAccessories)
    // console.log(DataAccessories);
    // setDataAccessories(updateAccessories);
    setInputFields(updatedFields);
    if (num_id >= inputFields.length) {
      setAddfield(true);
    }
  };
  const handleRemoveField = (id) => {
    if (id > 1) {
      setInputFields(inputFields.filter((field) => field.id !== id));
    } else {
      setInputFields([{ id: 1, value: "" }]);
    }
  };

  useEffect(() => {
    if (addfield === true) {
      if (inputFields.length !== 11) {
        setInputFields([
          ...inputFields,
          { id: inputFields[inputFields.length - 1].id + 1, value: "" },
        ]);
        setAddfield(false);
      }
    }
  }, [addfield]);

  const renderImgRemote = (props) => (
    <Tooltip {...props} className="remote-img" disabled>
      ตัวอย่าง อุปกรณ์ควบคุมการบิน
    </Tooltip>
  );

  const handleInputCurrency = (e) => {
    const enteredValue = e.target.value;
    const numericValue = parseInt(enteredValue.replace(/[^\d]/g, ""));
    setIns_limit(numericValue);
    if (!isNaN(numericValue)) {
      const formattedValue = formatCurrency(numericValue);
      setIns_limit_dummy(formattedValue);
    } else {
      setIns_limit_dummy("");
    }
  };

  const formatCurrency = (value) => {
    const formattedPrice = new Intl.NumberFormat("th-TH", {
      maximumSignificantDigits: 3,
      style: "currency",
      currency: "THB",
    }).format(value);

    return formattedPrice;
  };

  return (
    <div>
      <div className="container-main">
        <div style={{ marginBottom: "35px" }}>
          <h2 className="header-main">{t("registerRadio")}</h2>
        </div>
        {formType === 1 && (
          <>
            <div className="formtype-box">
              <div className="Headered-RgD" onClick={() => setFormType(1)}>
                1.{t("droneinfo")}
              </div>
              <div className="Header-RgD" onClick={() => setFormType(2)}>
                2.{t("insurance")}
              </div>
              <div className="Header-RgD" onClick={() => setFormType(3)}>
                3.{t("Profile.registrantinformation")}
              </div>
              <div className="Header-RgD" onClick={() => setFormType(4)}>
                4.{t("uploaddocuments")}
              </div>
            </div>
            {/* Navs Header */}

            <div className="form-section">
              <Form
                ref={form1}
                noValidate
                validated={validated}
                onSubmit={(e) => handleSend(e)}
              >
                <Form.Label>
                  {" "}
                  <h3 as={Col} md="12" className="header-main">
                    {t("droneinfo")}
                  </h3>
                </Form.Label>
                <Row className="mb-3 row-main">
                  <Form.Group as={Col} md="6">
                    <Form.Label className="font-cen">
                      {t("serialnumber")}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    {/* <div style={{width:"200px"}}>
                      <AutoComplete value={dummy} suggestions={items} completeMethod={search} onChange={(e) => setdummy(e.value)} style={{width:"500px"}}/>
                    </div> */}

                    <Form.Control
                      required
                      id="drone_sn"
                      type="text"
                      pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                      maxLength={50}
                      placeholder="กรอกเลข serial number"
                      className="form-input"
                      value={drone_sn}
                      onChange={(e) => {
                        setDroneserial(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevents the default "Enter" key behavior
                        }
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please use a-z 0-9
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} md="6">
                    <Form.Label className="font-cen">
                      {t("brand")}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      required
                      id="drone_brand"
                      type="text"
                      pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                      maxLength={50}
                      placeholder="ตราอักษร"
                      className="form-input"
                      value={brand}
                      onChange={(e) => {
                        setBrand(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevents the default "Enter" key behavior
                        }
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please use a-z 0-9
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} md="6">
                    <Form.Label className="font-cen">
                      {t("model")}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label className="font-cen">
                      {t("eq_install")}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Control
                      required
                      id="drone_model"
                      type="text"
                      pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                      maxLength={50}
                      placeholder="รุ่น"
                      className="form-input"
                      value={model}
                      onChange={(e) => {
                        setModel(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevents the default "Enter" key behavior
                        }
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please use a-z 0-9
                    </Form.Control.Feedback>
                  </Form.Group>

                  {inputFields.length === 1 ? (
                    <Form.Group as={Col} md="6">
                      {inputFields.map((field) => (
                        <div key={field.id} style={{ display: "flex" }}>
                          <Form.Select
                            className="form-selection"
                            value={field.value}
                            onChange={(e) =>
                              handleInputChange(field.id, e.target.value)
                            }
                          >
                            {dataAccessories.map((dataAcc) => (
                              <option value={dataAcc.id}>
                                {dataAcc.selection}
                              </option>
                            ))}
                          </Form.Select>

                          {/* <button
                            className="btn-Delselection"
                            onClick={() => handleRemoveField(field.id)}
                          ></button> */}
                        </div>
                      ))}
                      <p className="text-description">
                        (เป็นอุปรณ์ที่นำมาติดตั้งเพิ่มเติม ที่ไม่ได้มาจากโรงงาน)
                      </p>
                    </Form.Group>
                  ) : (
                    <Form.Group as={Col} md="6">
                      {inputFields.map((field) => (
                        <div
                          key={field.id}
                          style={{ padding: "2px", display: "flex" }}
                        >
                          <Form.Select
                            className="form-selection"
                            value={field.value}
                            onChange={(e) =>
                              handleInputChange(field.id, e.target.value)
                            }
                          >
                            {dataAccessories.map((dataAcc) => (
                              <option value={dataAcc.id}>
                                {dataAcc.selection}
                              </option>
                            ))}
                          </Form.Select>
                          <button
                            className="btn-Delselection"
                            onClick={() => handleRemoveField(field.id)}
                          ></button>
                        </div>
                      ))}
                    </Form.Group>
                  )}

                  <Form.Group as={Col} md="6" style={{ marginTop: "40px" }}>
                    <Form.Label className="font-cen">
                      {t("weight")}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <div>
                      <Form.Control
                        required
                        id="weight"
                        type="text"
                        placeholder="น้ำหนัก(Kg)"
                        className="form-input"
                        value={weight}
                        pattern="^\d*\.?\d*$"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value)) {
                            if (value < 2) {
                              setPurpose({
                                checkbox1: 1,
                                checkbox2: 0,
                                checkbox3: 0,
                                checkbox4: 0,
                                checkbox5: 0,
                                checkbox6: 0,
                                checkbox7: 0,
                                checkbox8: 0,
                                checkbox9: 0,
                                checkbox10: 0,
                                checkbox11: 0,
                                checkbox12: 0,
                                checkbox13: 0,
                              });
                            }
                            setWeight(value);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // Prevents the default "Enter" key behavior
                          }
                        }}
                      />
                      {/* // ตรวจสอบว่าเป็นตัวเลขหรือทศนิยมที่สมบูรณ์ก่อนแปลง
                          // const floatValue = parseFloat(value);
                          // if (!isNaN(floatValue)) 
                          //   // แปลงเป็น float และจำกัดทศนิยม 5 ตำแหน่งเมื่อกรอกเสร็จสิ้น
                          //   setWeight(parseFloat(floatValue.toFixed(5)));
                          //  */}
                      {/* <Form.Label className="font-cen">
                        <input
                          type="radio"
                          name="option1"
                          value="0"
                          checked={weight === 0}
                          onChange={() => {
                            setWeight(parseInt(0));
                          }}
                        />
                        &nbsp;"น้ำหนักไม่เกิน 2 กิโลกรัม"
                      </Form.Label>
                      <Form.Label className="font-cen">
                        <input
                          type="radio"
                          name="option1"
                          value="2"
                          checked={weight === 1}
                          onChange={() => {
                            setWeight(parseInt(1));
                          }}
                        />
                        &nbsp;"น้ำหนักเกินกว่า 2 กิโลกรัม แต่ไม่เกิน 25
                        กิโลกรัม"
                      </Form.Label> */}
                    </div>
                  </Form.Group>

                  <Form.Group as={Col} md="6" style={{ marginTop: "40px" }}>
                    <Form.Label className="font-cen">
                      {t("stdrid")}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <div>
                      <Form.Label className="font-cen">
                        <input
                          type="checkbox"
                          name="standardRemoteID"
                          value="0"
                          checked={stdRemoteID === false}
                          onChange={() => {
                            console.log(stdRemoteID);
                            if (stdRemoteID === false) {
                              setStdRemoteID(true);
                            } else {
                              setStdRemoteID(false);
                            }
                          }}
                        />
                        &nbsp; {t("stdrid")}
                      </Form.Label>
                    </div>
                  </Form.Group>

                  <div className="card-main" style={{ marginTop: "40px" }}>
                    <div style={{ display: "block" }}>
                      <Form.Label className="font-cen">
                        {t("frequency.head")}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox1"
                          value="1"
                          checked={frequency.checkbox1 === 1}
                          onChange={handleCheckboxChange}
                        />
                        &nbsp;{t("frequency.1")}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox2"
                          value="2"
                          checked={frequency.checkbox2 === 1}
                          onChange={handleCheckboxChange}
                        />
                        &nbsp;{t("frequency.2")}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox3"
                          value="3"
                          checked={frequency.checkbox3 === 1}
                          onChange={handleCheckboxChange}
                        />
                        &nbsp;{t("frequency.3")}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox4"
                          value="4"
                          checked={frequency.checkbox4 === 1}
                          onChange={handleCheckboxChange}
                        />
                        &nbsp;{t("frequency.4")}
                      </Form.Label>
                    </div>
                  </div>
                  <div style={{ height: "25px" }}></div>
                  <div className="card-main">
                    <div style={{ display: "block" }}>
                      <Form.Label
                        className="font-cen"
                        style={{ marginBottom: "-6.5px" }}
                      >
                        {t("purpose.head")}
                        <span style={{ color: "red" }}>*</span>
                        {/* (&nbsp;{weight}&nbsp;kg) */}
                      </Form.Label>
                      {/* <p className="text-description">
                        (หากโดรนของท่านมีน้ำหนักเท่ากับ 2 kg หรือมากกว่า 2 kg
                        ท่านสามารถเลือกได้มากกว่า 1 ข้อ)
                      </p> */}
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox1"
                          value={parseInt(0)}
                          checked={purpose.checkbox1 === 1}
                          onChange={handleCheckboxpurposeChange}
                        />
                        &nbsp;
                        {purposename[0] != null
                          ? purposename[0].purpose === t("purpose.1")
                            ? purposename[0].purpose
                            : t("purpose.1")
                          : ""}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox2"
                          value={parseInt(0)}
                          checked={purpose.checkbox2 === 1}
                          onChange={handleCheckboxpurposeChange}
                          disabled={
                            sessionStorage.getItem("type_user") === "user"
                              ? true
                              : false
                          }
                        />
                        &nbsp;
                        {purposename[1] != null
                          ? purposename[1].purpose === t("purpose.2")
                            ? purposename[1].purpose
                            : t("purpose.2")
                          : ""}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox3"
                          value={parseInt(0)}
                          checked={purpose.checkbox3 === 1}
                          onChange={handleCheckboxpurposeChange}
                          //disabled={weight < 2 ? true : false}
                        />
                        &nbsp;
                        {purposename[2] != null
                          ? purposename[2].purpose === t("purpose.3")
                            ? purposename[2].purpose
                            : t("purpose.3")
                          : ""}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox4"
                          value={parseInt(0)}
                          checked={purpose.checkbox4 === 1}
                          onChange={handleCheckboxpurposeChange}
                          //disabled={weight < 2 ? true : false}
                        />
                        &nbsp;
                        {purposename[3] != null
                          ? purposename[3].purpose === t("purpose.4")
                            ? purposename[3].purpose
                            : t("purpose.4")
                          : ""}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="gh"
                          value={parseInt(0)}
                          checked={openpurpose.open1 === 1}
                          onChange={() => {
                            if (openpurpose.open1 != 1) {
                              setOpenpurpose((prevCheckboxes) => ({
                                ...prevCheckboxes,
                                open1: 1,
                              }));
                            } else {
                              setOpenpurpose((prevCheckboxes) => ({
                                ...prevCheckboxes,
                                open1: 0,
                              }));
                              setPurpose((prevCheckboxes) => ({
                                ...prevCheckboxes,
                                checkbox5: 0,
                                checkbox6: 0,
                              }));
                            }
                          }}
                          // disabled={sessionStorage.getItem('type_user') === "user" ? true : false}
                        />
                        &nbsp;{t("purpose.open1")}
                      </Form.Label>
                      {openpurpose.open1 === 1 ? (
                        <>
                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox5"
                              value={parseInt(0)}
                              checked={purpose.checkbox5 === 1}
                              onChange={handleCheckboxpurposeChange}
                              // disabled={weight < 2 ? true : false}
                            />
                            &nbsp;
                            {purposename[4] != null
                              ? purposename[4].purpose === t("purpose.5")
                                ? purposename[4].purpose
                                : t("purpose.5")
                              : ""}
                          </Form.Label>
                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox6"
                              value={parseInt(0)}
                              checked={purpose.checkbox6 === 1}
                              onChange={handleCheckboxpurposeChange}
                              disabled={weight < 2 ? true : false}
                            />
                            &nbsp;
                            {purposename[5] != null
                              ? purposename[5].purpose === t("purpose.6")
                                ? purposename[5].purpose
                                : t("purpose.6")
                              : ""}
                          </Form.Label>
                        </>
                      ) : (
                        ""
                      )}
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="open2"
                          value={parseInt(0)}
                          checked={openpurpose.open2 === 1}
                          onChange={() => {
                            if (openpurpose.open2 != 1) {
                              setOpenpurpose((prevCheckboxes) => ({
                                ...prevCheckboxes,
                                open2: 1,
                              }));
                              setPurpose((prevCheckboxes) => ({
                                ...prevCheckboxes,
                                checkbox7: 1,
                              }));
                            } else {
                              setOpenpurpose((prevCheckboxes) => ({
                                ...prevCheckboxes,
                                open2: 0,
                              }));
                              setPurpose((prevCheckboxes) => ({
                                ...prevCheckboxes,
                                checkbox8: 0,
                                checkbox9: 0,
                                checkbox10: 0,
                                checkbox11: 0,
                                checkbox12: 0,
                                checkbox13: 0,
                              }));
                            }
                          }}
                          //disabled={weight < 2 ? true : false}
                        />
                        &nbsp;
                        {purposename[6] != null
                          ? purposename[6].purpose === t("purpose.7")
                            ? purposename[6].purpose
                            : t("purpose.7")
                          : ""}
                      </Form.Label>
                      {openpurpose.open2 === 1 ? (
                        <>
                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox8"
                              value={parseInt(0)}
                              checked={purpose.checkbox8 === 1}
                              onChange={handleCheckboxpurposeChange}
                              //disabled={weight < 2 ? true : false}
                            />
                            &nbsp;
                            {purposename[7] != null
                              ? purposename[7].purpose === t("purpose.8")
                                ? purposename[7].purpose
                                : t("purpose.8")
                              : ""}
                          </Form.Label>
                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox9"
                              value={parseInt(0)}
                              checked={purpose.checkbox9 === 1}
                              onChange={handleCheckboxpurposeChange}
                              //disabled={weight < 2 ? true : false}
                            />
                            &nbsp;
                            {purposename[8] != null
                              ? purposename[8].purpose === t("purpose.9")
                                ? purposename[8].purpose
                                : t("purpose.9")
                              : ""}
                          </Form.Label>
                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox10"
                              value={parseInt(0)}
                              checked={purpose.checkbox10 === 1}
                              onChange={handleCheckboxpurposeChange}
                              //disabled={weight < 2 ? true : false}
                            />
                            &nbsp;
                            {purposename[9] != null
                              ? purposename[9].purpose === t("purpose.10")
                                ? purposename[9].purpose
                                : t("purpose.10")
                              : ""}
                          </Form.Label>
                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox11"
                              value={parseInt(0)}
                              checked={purpose.checkbox11 === 1}
                              onChange={handleCheckboxpurposeChange}
                              //disabled={weight < 2 ? true : false}
                            />
                            &nbsp;
                            {purposename[10] != null
                              ? purposename[10].purpose === t("purpose.11")
                                ? purposename[10].purpose
                                : t("purpose.11")
                              : ""}
                          </Form.Label>
                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox12"
                              value={parseInt(0)}
                              checked={purpose.checkbox12 === 1}
                              onChange={handleCheckboxpurposeChange}
                              //disabled={weight < 2 ? true : false}
                            />
                            &nbsp;
                            {purposename[11] != null
                              ? purposename[11].purpose === t("purpose.12")
                                ? purposename[11].purpose
                                : t("purpose.12")
                              : ""}
                          </Form.Label>
                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox13"
                              value={parseInt(0)}
                              checked={purpose.checkbox13 === 1}
                              onChange={handleCheckboxpurposeChange}
                              //disabled={weight < 2 ? true : false}
                            />
                            &nbsp;
                            {purposename[12] != null
                              ? purposename[12].purpose === t("purpose.13")
                                ? purposename[12].purpose
                                : t("purpose.13")
                              : ""}
                          </Form.Label>

                          <Form.Label
                            className="font-censize"
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="checkbox"
                              name="checkbox7"
                              value={parseInt(0)}
                              checked={purpose.checkbox7 === 1}
                              onChange={handleCheckboxpurposeChange}
                              //disabled={weight < 2 ? true : false}
                            />
                            &nbsp;{t("purpose.etc")} &nbsp;
                            <input
                              type="text"
                              name="input"
                              value={purpose_etc}
                              disabled={purpose.checkbox7 === 0}
                              onChange={(e) => setPurposeEtc(e.target.value)}
                              style={{ width: "400px" }}
                            />
                            &nbsp;
                          </Form.Label>
                        </>
                      ) : (
                        ""
                      )}

                      {/* {purpose.checkbox7 === 1 && (
                        <Form.Label className="font-censize">
                          <input
                            type="text"
                            name="input"
                            value={purposecomment}
                            checked={purpose.checkbox7 === 1}
                            onChange={(e) => setPurposecomment(e.target.value)}
                            style={{ width: "400px" }}
                          />
                          &nbsp;
                        </Form.Label>
                      )} */}
                    </div>
                  </div>
                </Row>

                <Row className="mb-3 row-main">
                  <Form.Group as={Col} md="6">
                    <Form.Label className="font-cen">
                      {t("remote_brand")}
                      <span style={{ color: "red" }}>* </span>
                      <OverlayTrigger
                        placement="right-end"
                        delay={{ show: 250, hide: 300 }}
                        overlay={renderImgRemote}
                        style={{ marginTop: "1.5%" }}
                      >
                        <button
                          className="btn-Overlay-Trigger"
                          disabled
                        ></button>
                      </OverlayTrigger>
                    </Form.Label>
                  </Form.Group>

                  <Form.Group as={Col} md="6">
                    <Form.Label className="font-cen">
                      {t("remote_sn")}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Control
                      required
                      id="remote_brand"
                      type="text"
                      pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                      maxLength={50}
                      className="form-input"
                      value={remote_brand}
                      onChange={(e) => {
                        setRemote_brand(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevents the default "Enter" key behavior
                        }
                      }}
                    />
                  </Form.Group>

                  <Form.Group as={Col} md="6">
                    <Form.Control
                      required
                      id="remote_sn"
                      type="text"
                      pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                      maxLength={50}
                      className="form-input"
                      value={remote_sn}
                      onChange={(e) => {
                        setRemote_sn(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevents the default "Enter" key behavior
                        }
                      }}
                    />
                  </Form.Group>
                </Row>
                <Row
                  className="mb-3 row-main"
                  style={{
                    marginTop: "90px",
                  }}
                >
                  <Form.Label>
                    <h3 as={Col} className="header-main">
                      {t("lic.head")}
                    </h3>
                  </Form.Label>
                  <div className="card-main">
                    <div style={{ display: "block" }}>
                      <Form.Label className="font-censize">
                        <input
                          id=""
                          type="checkbox"
                          name="option1"
                          value="1"
                          checked={chooselicense === "1"}
                          onChange={handleOptionChange}
                        />
                        &nbsp;{t("lic.1")}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="option2"
                          value="2"
                          checked={chooselicense === "2"}
                          onChange={handleOptionChange}
                        />
                        {t("lic.2")}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="option3"
                          value="3"
                          checked={chooselicense === "3"}
                          onChange={handleOptionChange}
                        />
                        {t("lic.3")}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="option4"
                          value="4"
                          checked={chooselicense === "4"}
                          onChange={handleOptionChange}
                        />
                        {t("lic.4")}
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="option5"
                          value="5"
                          checked={chooselicense === "5"}
                          onChange={handleOptionChange}
                        />
                        {t("lic.5")}
                      </Form.Label>
                    </div>
                    {chooselicense === "1" ? (
                      <div
                        style={{
                          position: "relative",
                          marginLeft: "150px",
                        }}
                      >
                        <Form.Label className="font-censize">
                          {t("lic.101")}
                          <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos1_1"
                          type="text"
                          name="file2"
                          pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                          maxLength={50}
                          //disabled
                          value={lic_req_data}
                          onChange={(e) => setLic_req_data(e.target.value)}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          {t("lic.102")}
                          <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos1_2"
                          type="date"
                          name="file2"
                          value={lic_req_data1}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data1(e.target.value);
                            }
                          }}
                          //disabled
                          className="form-input"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {chooselicense === "2" ? (
                      <div
                        style={{
                          position: "relative",
                          marginLeft: "150px",
                        }}
                      >
                        <Form.Label className="font-censize">
                          {t("lic.201")}
                          <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos2_1"
                          pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                          maxLength={50}
                          type="text"
                          name="file2"
                          //disabled
                          value={lic_req_data}
                          onChange={(e) => setLic_req_data(e.target.value)}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          {t("lic.202")}
                          <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos2_2"
                          type="date"
                          name="file2"
                          //disabled
                          value={lic_req_data1}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data1(e.target.value);
                            }
                          }}
                          className="form-input"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {chooselicense === "3" ? (
                      <div
                        style={{
                          position: "relative",
                          marginLeft: "100px",
                        }}
                      >
                        <Form.Label className="font-censize">
                          {t("lic.301")}
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos3_1"
                          type="date"
                          name="date"
                          //disabled
                          value={lic_req_data}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data(e.target.value);
                            }
                          }}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          {t("lic.302")}
                          <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos3_2"
                          type="text"
                          pattern="[0-9]*"
                          maxLength={50}
                          name="date"
                          //disabled
                          value={lic_req_data1}
                          onChange={(e) => setLic_req_data1(e.target.value)}
                          className="form-input"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {chooselicense === "5" ? (
                      <div
                        style={{
                          position: "relative",
                          marginLeft: "100px",
                        }}
                      >
                        <Form.Label className="font-censize">
                          {t("lic.501")}
                          <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos5_1"
                          type="text"
                          name="file2"
                          pattern="[0-9]*"
                          maxLength={50}
                          //disabled
                          value={lic_req_data}
                          onChange={(e) => setLic_req_data(e.target.value)}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          {t("lic.502")}
                          <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos5_2"
                          type="date"
                          name="date"
                          //disabled
                          value={lic_req_data1}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data1(e.target.value);
                            }
                          }}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          {t("lic.503")}
                          <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          className="form-input"
                          id="choos5_3"
                          type="date"
                          name="date"
                          //disabled
                          value={lic_req_data2}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data2(e.target.value);
                            }
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Row>
              </Form>
            </div>
            <div className="modal-body-grid2">
              <div className="grid-item"></div>
              <div
                className="grid-item"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <button
                  className="custom-btn btnSave"
                  style={{ width: "150px", fontSize: "22px" }}
                  onClick={() => {
                    setFormType(2);
                  }}
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </>
        )}

        {formType === 2 && (
          <>
            <div className="formtype-box">
              <div className="Header-RgD" onClick={() => setFormType(1)}>
                1.{t("droneinfo")}
              </div>
              <div className="Headered-RgD" onClick={() => setFormType(2)}>
                2.{t("insurance")}
              </div>
              <div className="Header-RgD" onClick={() => setFormType(3)}>
                3.{t("Profile.registrantinformation")}
              </div>
              <div className="Header-RgD" onClick={() => setFormType(4)}>
                4.{t("uploaddocuments")}
              </div>
            </div>
            {/* Navs Header */}
            {weight >= 2 || (weight < 2 && checkisu === false) ? (
              <div className="form-section">
                <Form
                  ref={form1}
                  noValidate
                  validated={validated}
                  onSubmit={(e) => handleSend(e)}
                >
                  <Form.Label>
                    <h3 as={Col} className="header-main">
                      {t("insurance")}
                    </h3>
                  </Form.Label>
                  <Row className="mb-3 row-main">
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        {t("ins_type")}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_type"
                        type="text"
                        placeholder=""
                        maxLength={50}
                        disabled
                        className="form-input"
                        value="กรมธรรม์ภัยความรับผิดตามกฎหมายต่อบุคคลภายนอก"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        {t("ins_number")}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 ? false : true}
                        id="ins_number"
                        type="text"
                        pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                        maxLength={50}
                        //disabled
                        className="form-input"
                        value={ins_number}
                        onChange={(e) => {
                          setIns_number(e.target.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        {t("ins_company_name")}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        {t("ins_limit")}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>

                      <Form.Control.Feedback type="invalid">
                        กรุณาใส่จำนวนวงเงินตั้งแต่ 1,000,000 บาทค่ะ
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_company_name"
                        type="text"
                        placeholder=""
                        //disabled
                        className="form-input"
                        value={ins_company_name}
                        onChange={(e) => {
                          setIns_company_name(e.target.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_limit"
                        min={1000000}
                        maxLength={12}
                        type="text"
                        placeholder=" > 1,000,000 THB"
                        //disabled
                        className="form-input"
                        value={ins_limit_dummy}
                        onChange={handleInputCurrency}
                      />
                      <Form.Control.Feedback type="invalid">
                        กรุณาใส่จำนวนวงเงินตั้งแต่ 1,000,000 บาทค่ะ
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        {t("ins_start")}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_start"
                        type="date"
                        placeholder=""
                        //disabled
                        className="form-input"
                        value={ins_start}
                        onChange={(e) => {
                          if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                            setIns_start(e.target.value);
                          }
                        }}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        {t("ins_end")}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_end"
                        type="date"
                        placeholder=""
                        //disabled
                        className="form-input"
                        value={ins_end}
                        onChange={(e) => {
                          if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                            setIns_end(e.target.value);
                          }
                        }}
                      />
                    </Form.Group>
                  </Row>

                  {/* <Row
                    className="mb-3 row-main"
                    style={{
                      marginTop: "90px",
                    }}
                  >
                    <Form.Label>
                      <h3 as={Col} className="header-main">
                        วันที่ครอบครองเครื่องวิทยุคมนาคมที่ใช้ในอากาศยานซึ่งไม่มีนักบิน
                      </h3>
                    </Form.Label>
                    <div className="card-main">
                      <div style={{ display: "block" }}>
                        <Form.Label className="font-censize">
                          <input
                            id=""
                            type="checkbox"
                            name="option1"
                            value="1"
                            checked={chooselicense === "1"}
                            onChange={handleOptionChange}
                          />
                          &nbsp;นำเข้าตามใบอนุญาตนำเข้า
                          <br />
                          Imported according to the Import License
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            type="checkbox"
                            name="option2"
                            value="2"
                            checked={chooselicense === "2"}
                            onChange={handleOptionChange}
                          />
                          ซื้อจากร้านค้า
                          <br />
                          Purchased from the distributor/store
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            type="checkbox"
                            name="option3"
                            value="3"
                            checked={chooselicense === "3"}
                            onChange={handleOptionChange}
                          />
                          นำเข้ามาใช้งานในประเทศเป็นการชั่วคราว
                          <br />
                          Temporarilty imported in to the country
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            type="checkbox"
                            name="option4"
                            value="4"
                            checked={chooselicense === "4"}
                            onChange={handleOptionChange}
                          />
                          รับโอนจากบุคคลอื่น
                          <br />
                          Transfered from the others
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            type="checkbox"
                            name="option5"
                            value="5"
                            checked={chooselicense === "5"}
                            onChange={handleOptionChange}
                          />
                          ทำขึ้นตามใบอนุญาต
                          <br />
                          Made according to the Assembly License
                        </Form.Label>
                      </div>
                      {chooselicense === "1" ? (
                        <div
                          style={{
                            position: "relative",
                            marginLeft: "150px",
                          }}
                        >
                          <Form.Label className="font-censize">
                            เลขใบอนุญาตนำเข้า<span className="text-red">*</span>
                            <br />
                            Import license number{" "}
                          </Form.Label>
                          <Form.Control
                            required
                            id="choos1_1"
                            type="text"
                            name="file2"
                            pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                            maxLength={50}
                            //disabled
                            value={lic_req_data}
                            onChange={(e) => setLic_req_data(e.target.value)}
                            className="form-input"
                          />
                          <Form.Label className="font-censize">
                            วันที่นำเข้า (วัน/เดือน/ปี พ.ศ.)
                            <span className="text-red">*</span>
                            <br />
                            Import date (d M yyyy)
                          </Form.Label>
                          <Form.Control
                            required
                            id="choos1_2"
                            type="date"
                            name="file2"
                            value={lic_req_data1}
                            onChange={(e) => {
                              if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                                setLic_req_data1(e.target.value);
                              }
                            }}
                            //disabled
                            className="form-input"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {chooselicense === "2" ? (
                        <div
                          style={{
                            position: "relative",
                            marginLeft: "150px",
                          }}
                        >
                          <Form.Label className="font-censize">
                            ชื่อร้านค้า<span className="text-red">*</span>
                            <br />
                            Store name{" "}
                          </Form.Label>
                          <Form.Control
                            required
                            id="choos2_1"
                            pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                            maxLength={50}
                            type="text"
                            name="file2"
                            //disabled
                            value={lic_req_data}
                            onChange={(e) => setLic_req_data(e.target.value)}
                            className="form-input"
                          />
                          <Form.Label className="font-censize">
                            ตามใบเสร็จ/ใบกำกับภาษี ลงวันที่ (วัน/เดือน/ปี พ.ศ.)
                            <span className="text-red">*</span>
                            <br />
                            Bill date (d M yyyy)
                          </Form.Label>
                          <Form.Control
                            required
                            id="choos2_2"
                            type="date"
                            name="file2"
                            //disabled
                            value={lic_req_data1}
                            onChange={(e) => {
                              if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                                setLic_req_data1(e.target.value);
                              }
                            }}
                            className="form-input"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {chooselicense === "3" ? (
                        <div
                          style={{
                            position: "relative",
                            marginLeft: "100px",
                          }}
                        >
                          <Form.Label className="font-censize">
                            วันที่เดินทางเข้าประเทศไทย/ Arrival date (mm dd,
                            yyyy){" "}
                          </Form.Label>
                          <Form.Control
                            required
                            id="choos3_1"
                            type="date"
                            name="date"
                            //disabled
                            value={lic_req_data}
                            onChange={(e) => {
                              if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                                setLic_req_data(e.target.value);
                              }
                            }}
                            className="form-input"
                          />
                          <Form.Label className="font-censize">
                            จำนวนวันที่พำนักในประเทศไทย (วัน)/
                            <span className="text-red">*</span>
                            <br />
                            Number of days of stay in Thailand (days)
                          </Form.Label>
                          <Form.Control
                            required
                            id="choos3_2"
                            type="text"
                            pattern="[0-9]*"
                            maxLength={50}
                            name="date"
                            //disabled
                            value={lic_req_data1}
                            onChange={(e) => setLic_req_data1(e.target.value)}
                            className="form-input"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {chooselicense === "5" ? (
                        <div
                          style={{
                            position: "relative",
                            marginLeft: "100px",
                          }}
                        >
                          <Form.Label className="font-censize">
                            เลขที่ใบอนุญาตทำ<span className="text-red">*</span>
                            <br />
                            license number
                          </Form.Label>
                          <Form.Control
                            required
                            id="choos5_1"
                            type="text"
                            name="file2"
                            pattern="[0-9]*"
                            maxLength={50}
                            //disabled
                            value={lic_req_data}
                            onChange={(e) => setLic_req_data(e.target.value)}
                            className="form-input"
                          />
                          <Form.Label className="font-censize">
                            วันที่ใบอนุญาตทำ (วัน/เดือน/ปี พ.ศ.)
                            <span className="text-red">*</span>
                            <br />
                            license date(d M yyyy)
                          </Form.Label>
                          <Form.Control
                            required
                            id="choos5_2"
                            type="date"
                            name="date"
                            //disabled
                            value={lic_req_data1}
                            onChange={(e) => {
                              if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                                setLic_req_data1(e.target.value);
                              }
                            }}
                            className="form-input"
                          />
                          <Form.Label className="font-censize">
                            วันที่ทำเครื่องวิทยุคมนาคม (วัน/เดือน/ปี พ.ศ.)
                            <span className="text-red">*</span>
                            <br />
                            made date radio communication device (d M yyyy)
                          </Form.Label>
                          <Form.Control
                            required
                            className="form-input"
                            id="choos5_3"
                            type="date"
                            name="date"
                            //disabled
                            value={lic_req_data2}
                            onChange={(e) => {
                              if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                                setLic_req_data2(e.target.value);
                              }
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </Row> */}
                </Form>
              </div>
            ) : (
              <div
                className="form-section"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "30px",
                }}
              >
                ท่านไม่ต้องทำเรื่องเอกสารประกันเนื่องจากน้ำหนักของโดรนไม่ถึงเกณฑ์
              </div>
            )}

            <div className="modal-body-grid2">
              <div className="grid-item">
                <button
                  className="custom-btn btnCancel"
                  style={{ width: "150px", fontSize: "22px" }}
                  onClick={() => {
                    setFormType(1);
                  }}
                >
                  {t("previous")}
                </button>
              </div>
              <div
                className="grid-item"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <button
                  className="custom-btn btnSave"
                  style={{ width: "150px", fontSize: "22px" }}
                  onClick={() => {
                    setFormType(3);
                  }}
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </>
        )}

        {formType === 3 &&
          (sessionStorage.getItem("type_user") === "corporation" ? (
            <>
              <div className="formtype-box">
                <div className="Header-RgD" onClick={() => setFormType(1)}>
                  1.{t("droneinfo")}
                </div>
                <div className="Header-RgD" onClick={() => setFormType(2)}>
                  2.{t("insurance")}
                </div>
                <div className="Headered-RgD" onClick={() => setFormType(3)}>
                  3.{t("Profile.registrantinformation")}
                </div>
                <div className="Header-RgD" onClick={() => setFormType(4)}>
                  4.{t("uploaddocuments")}
                </div>
              </div>

              <div className="form-section">
                <Form
                  ref={form1}
                  noValidate
                  validated={validated}
                  onSubmit={(e) => handleSend(e)}
                >
                  <Row className="mb-3 row-main">
                    <Form.Group as={Col} md="12">
                      <div style={{ display: "flex", width: "500px" }}>
                        <h3 as={Col} className="header-main">
                          ข้อมูลส่วนตัว
                        </h3>

                        <Button
                          onClick={editdrone}
                          //disabled={!disabless}
                          className="btnEdit"
                        >
                          <h4>แก้ไข</h4>
                        </Button>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        เลขทะเบียนนิติบุคคล
                      </Form.Label>
                      <Form.Control
                        disabled
                        className="form-input"
                        type="text"
                        value={data.legalentity_number}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        รหัสสาขา (ภพ. 20)
                      </Form.Label>
                      <Form.Control
                        disabled
                        required
                        type="text"
                        //placeholder={data.f_name}
                        value={data.branch_code}
                        className="form-input"
                      />
                      <Form.Control.Feedback>!</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">อีเมล</Form.Label>
                      <Form.Control
                        disabled
                        required
                        type="text"
                        //placeholder={data.l_name}
                        value={data.email}
                        className="form-input"
                      />
                      <Form.Control.Feedback>!</Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row className="mb-3 row-main">
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                      </Form.Label>
                      <Form.Control
                        disabled
                        className="form-input"
                        type="text"
                        value={data.cur_address}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">จังหวัด</Form.Label>
                      <>
                        <Form.Control
                          disabled
                          className="form-input"
                          type="text"
                          value={data.cur_province ? data.cur_province : ""}
                        />
                      </>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">ตำบล</Form.Label>
                      <>
                        <Form.Control
                          disabled
                          className="form-input"
                          type="text"
                          value={data.cur_sub_dis ? data.cur_sub_dis : ""}
                        />
                      </>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">อำเภอ</Form.Label>
                      <>
                        <Form.Control
                          disabled
                          className="form-input"
                          type="text"
                          value={data.cur_dis ? data.cur_dis : ""}
                        />
                      </>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                      <>
                        <Form.Control
                          disabled
                          className="form-input"
                          type="text"
                          value={data.cur_poscode ? data.cur_poscode : ""}
                        />
                      </>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        เบอร์โทรศัพท์
                      </Form.Label>
                      <Form.Control
                        disabled
                        className="form-input"
                        type="text"
                        //placeholder={data.l_name}
                        value={data.phone ? data.phone : ""}
                      />
                      <Form.Control.Feedback>!</Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Form>
              </div>
              <div className="modal-body-grid2">
                <div className="grid-item">
                  <button
                    className="custom-btn btnCancel"
                    style={{ width: "150px", fontSize: "22px" }}
                    onClick={() => {
                      setFormType(2);
                    }}
                  >
                    {t("previous")}
                  </button>
                </div>
                <div
                  className="grid-item"
                  style={{ display: "flex", justifyContent: "end" }}
                >
                  <button
                    className="custom-btn btnSave"
                    style={{ width: "150px", fontSize: "22px" }}
                    onClick={() => {
                      setFormType(4);
                    }}
                  >
                    {t("next")}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="formtype-box">
                <div className="Header-RgD" onClick={() => setFormType(1)}>
                  1.{t("droneinfo")}
                </div>
                <div className="Header-RgD" onClick={() => setFormType(2)}>
                  2.{t("insurance")}
                </div>
                <div className="Headered-RgD" onClick={() => setFormType(3)}>
                  3.{t("Profile.registrantinformation")}
                </div>
                <div className="Header-RgD" onClick={() => setFormType(4)}>
                  4.{t("uploaddocuments")}
                </div>
              </div>
              {/* Navs Header */}
              <div className="form-section">
                <Form
                  ref={form1}
                  noValidate
                  validated={validated}
                  onSubmit={(e) => handleSend(e)}
                >
                  <Row className="mb-3 row-main">
                    <Form.Group as={Col} md="12">
                      <div style={{ display: "flex", width: "500px" }}>
                        <h4 as={Col} className="header-main">
                          {t("Profile.registrantinformation")}
                        </h4>

                        <Button
                          onClick={editdrone}
                          //disabled={!disabless}
                          className="btnEdit"
                        >
                          <h4>แก้ไข</h4>
                        </Button>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.title")}
                      </Form.Label>

                      <Form.Control
                        disabled
                        value={data.title}
                        className="form-input"
                      ></Form.Control>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.FirstNamethai")}
                      </Form.Label>
                      <Form.Control
                        required
                        disabled={disabless}
                        type="text"
                        value={data.f_name}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.LastNamethai")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.l_name}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        {t("Profile.idnum")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="number"
                        //value="1-2345-12345-12-3"
                        value={data.idnum}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.email")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="email"
                        //value="name@example.com"
                        value={data.email}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.phone")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="number"
                        aria-label="Amount (to the nearest dollar)"
                        value={data.phone}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.occupation")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.occupation}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">
                        {t("Profile.dateofbirth")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        //type="date"
                        value={data.date_of_birth}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">
                        {t("Profile.age")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="number"
                        value={data.age}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">
                        {t("Profile.ethnicity")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.race}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">
                        {t("Profile.nationality")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.nationality}
                        className="form-input"
                      />
                    </Form.Group>
                  </Row>
                  <Row
                    className="mb-3"
                    style={{
                      marginTop: "75px",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "1608px",
                      fontSize: "28px",
                      width: "100%",
                      padding: "0px 10px",
                    }}
                  >
                    <Form.Label>
                      <h3 as={Col} className="header-main">
                        {t("Profile.addressIdcard")}
                      </h3>
                    </Form.Label>
                    <Form.Group as={Col} md="8">
                      <Form.Label className="font-cen">
                        {t("Profile.addressIdcard")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.address}
                        className="form-input"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.province")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.province}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.subdistrict")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.sub_dis}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.district")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.dis}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.zipcode")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="number"
                        value={data.pos_code}
                        className="form-input"
                      />
                    </Form.Group>
                  </Row>

                  <Row
                    className="mb-3 row-main"
                    style={{
                      marginTop: "75px",
                    }}
                  >
                    <Form.Group as={Col} md="12">
                      <Form.Label>
                        <h3 as={Col} className="header-main">
                          {t("Profile.addresscurrent")}
                        </h3>
                      </Form.Label>
                    </Form.Group>

                    <Form.Group as={Col} md="8">
                      <Form.Label className="font-cen">
                        {t("Profile.address")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.cur_address}
                        className="form-input"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.province")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.cur_province}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.subdistrict")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.cur_sub_dis}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.district")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="text"
                        value={data.cur_dis}
                        className="form-input"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        {t("Profile.zipcode")}
                      </Form.Label>
                      <Form.Control
                        disabled={disabless}
                        type="number"
                        value={data.cur_poscode}
                        className="form-input"
                      />
                    </Form.Group>
                  </Row>
                </Form>
              </div>
              <div className="modal-body-grid2">
                <div className="grid-item">
                  <button
                    className="custom-btn btnCancel"
                    style={{ width: "150px", fontSize: "22px" }}
                    onClick={() => {
                      setFormType(2);
                    }}
                  >
                    {t("previous")}
                  </button>
                </div>
                <div
                  className="grid-item"
                  style={{ display: "flex", justifyContent: "end" }}
                >
                  <button
                    className="custom-btn btnSave"
                    style={{ width: "150px", fontSize: "22px" }}
                    onClick={() => {
                      setFormType(4);
                    }}
                  >
                    {t("Next")}
                  </button>
                </div>
              </div>
            </>
          ))}

        {formType === 4 && (
          <>
            <div className="formtype-box">
              <div className="Header-RgD" onClick={() => setFormType(1)}>
                1.{t("droneinfo")}
              </div>
              <div className="Header-RgD" onClick={() => setFormType(2)}>
                2.{t("insurance")}
              </div>
              <div className="Header-RgD" onClick={() => setFormType(3)}>
                3.{t("Profile.registrantinformation")}
              </div>
              <div className="Headered-RgD" onClick={() => setFormType(4)}>
                4.{t("uploaddocuments")}
              </div>
            </div>
            {/* Navs Header */}

            <div className="form-section">
              <Form
                ref={form1}
                noValidate
                validated={validated}
                onSubmit={(e) => handleSend(e)}
              >
                <Row className="mb-3 row-main">
                  <Form.Label>
                    <h3 as={Col} className="header-main">
                      {t("uploaddocuments")}
                    </h3>
                  </Form.Label>
                  <Form.Group as={Col} md="12">
                    <Form.Label
                      className="font-cen"
                      style={{ fontSize: "30px" }}
                    >
                      {t("identitydocuments")}
                    </Form.Label>
                    <Form.Label className="font-cen">
                      {t("copyidcard")}
                      <span style={{ color: "red" }}>***</span>
                    </Form.Label>

                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          id="idcard_file"
                          name="idcard_file"
                          type="file"
                          accept=".pdf, .jpg, .png"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                          //disabled={disabless}
                          className="form-importf"
                        />
                      </Col>

                      <Col>
                        <Form.Control
                          required
                          md={7}
                          className="form-import-val"
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.idcard_file === null
                              ? ""
                              : files.idcard_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label className="font-cen">
                      {t("copyhouseregis")}
                      <span style={{ color: "red" }}>***</span>
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          id="homeregis_file"
                          type="file"
                          accept=".pdf, .jpg, .png"
                          name="homeregis_file"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                          //disabled
                          className="form-importf"
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          required
                          className="form-import-val"
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.homeregis_file === null
                              ? ""
                              : files.homeregis_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label
                      className="font-cen"
                      style={{ fontSize: "30px" }}
                    >
                      {t("technicaldocuments")}
                    </Form.Label>
                    <Form.Label className="font-cen">
                      {t("UAVPicture")}
                      <span style={{ color: "red" }}>***</span>
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          id="dronepic_file"
                          type="file"
                          name="dronepic_file"
                          accept=".pdf, .jpg, .png"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                          //disabled
                          className="form-importf"
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          required
                          className="form-import-val"
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.dronepic_file === null
                              ? ""
                              : files.dronepic_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label className="font-cen">
                      {t("pictureDrone")}
                      <span style={{ color: "red" }}>***</span>
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          id="droneserial_file"
                          type="file"
                          name="droneserial_file"
                          accept=".pdf, .jpg, .png"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                          //disabled
                          className="form-importf"
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          required
                          className="form-import-val"
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.droneserial_file === null
                              ? ""
                              : files.droneserial_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label className="font-cen">
                      {t("pictureremote")}
                      <span style={{ color: "red" }}>***</span>
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          id="remoteserial_file"
                          type="file"
                          name="remoteserial_file"
                          accept=".pdf, .jpg, .png"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                          //disabled
                          className="form-importf"
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          required
                          className="form-import-val"
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.remoteserial_file === null
                              ? ""
                              : files.remoteserial_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label className="font-cen">
                      {t("selfcertification")}
                      <span style={{ color: "red" }}>***</span>
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          id="selfcert_file"
                          type="file"
                          name="selfcert_file"
                          accept=".pdf, .jpg, .png"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                          //disabled
                          className="form-importf"
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          required
                          className="form-import-val"
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.selfcert_file === null
                              ? ""
                              : files.selfcert_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>

                  {weight >= 2 || (weight < 2 && checkisu === false) ? (
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        {t("copyinsdoc")}
                        <span style={{ color: "red" }}>***</span>
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            id="aircraft_insu_file"
                            type="file"
                            name="aircraft_insu_file"
                            accept=".pdf, .jpg, .png"
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            //disabled
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <Form.Control
                            required={
                              weight >= 2 || (weight < 2 && checkisu === false)
                                ? true
                                : false
                            }
                            className="form-import-val"
                            type="text"
                            placeholder="No file Chosen....."
                            value={
                              files.aircraft_insu_file === null
                                ? ""
                                : files.aircraft_insu_file.name
                            }
                          />
                        </Col>
                      </Row>
                    </Form.Group>
                  ) : (
                    ""
                  )}

                  <Form.Group as={Col} md="12">
                    <Form.Label
                      className="font-cen"
                      style={{ fontSize: "30px" }}
                    >
                      {t("addsupportdoc")}
                    </Form.Label>
                    <Form.Label className="font-cen">
                      {t("powerAttorneydocument")}
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          //required
                          id="attorney_doc_file"
                          type="file"
                          name="attorney_doc_file"
                          accept=".pdf, .jpg, .png"
                          //disabled
                          className="form-importf"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          className="form-import-val"
                          // disabled
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.attorney_doc_file === null
                              ? ""
                              : files.attorney_doc_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label className="font-cen">
                      {t("copyauthid")}
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          //required
                          id="idcard_attorneyauth_file"
                          type="file"
                          name="idcard_attorneyauth_file"
                          accept=".pdf, .jpg, .png"
                          //disabled
                          className="form-importf"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          className="form-import-val"
                          // disabled
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.idcard_attorneyauth_file === null
                              ? ""
                              : files.idcard_attorneyauth_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label className="font-cen">
                      {t("copyattornid")}
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          //required
                          id="idcard_attorney_file"
                          type="file"
                          name="idcard_attorney_file"
                          accept=".pdf, .jpg, .png"
                          //disabled
                          className="form-importf"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          className="form-import-val"
                          // disabled
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.idcard_attorney_file === null
                              ? ""
                              : files.idcard_attorney_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Group as={Col} md="12">
                    <Form.Label
                      className="font-cen"
                      style={{ fontSize: "30px" }}
                    >
                      {t("legaldoc")}
                    </Form.Label>
                    <Form.Label className="font-cen">
                      {t("legalresult")}
                    </Form.Label>
                    <Row className="mb-3">
                      <Col md={2} style={{ display: "block" }}>
                        <Form.Control
                          //required
                          id="legal_result_file"
                          type="file"
                          name="legal_result_file"
                          accept=".pdf, .jpg, .png"
                          //disabled
                          className="form-importf"
                          onChange={(e) => {
                            handleFiles(e);
                          }}
                        />
                      </Col>
                      <Col md={10}>
                        <Form.Control
                          className="form-import-val"
                          // disabled
                          type="text"
                          placeholder="No file Chosen....."
                          value={
                            files.legal_result_file === null
                              ? ""
                              : files.legal_result_file.name
                          }
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>

                <div className="modal-body-grid2" style={{ alignItems: "end" }}>
                  <div className="grid-item">
                    <button
                      className="custom-btn btnCancel"
                      style={{ width: "150px", fontSize: "22px" }}
                      onClick={() => {
                        setFormType(3);
                      }}
                    >
                      {t("previous")}
                    </button>
                  </div>

                  <div
                    className="grid-item"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    {/* <button
                      className="custom-btn btnSave"
                      style={{
                        width: "200px",
                        fontSize: "24px",
                      }}
                      onClick={() => {
                        setSaveupdate(true);
                        setShow(true);
                        console.log(saveupdate)
                      }}
                    >
                      บันทึกข้อมูล
                    </button> */}
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="custom-btn btnConfirm"
                      style={{ width: "200px", fontSize: "24px" }}
                      onClick={() => {
                        setLastupdate(true);
                        setSaveupdate(false);
                      }}
                    >
                      {t("submitdata")}
                    </button>
                  </div>
                </div>
              </Form>
              <br />
              <div
                className="grid-item"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <button
                  className="custom-btn btnEdit2"
                  style={{
                    width: "200px",
                    fontSize: "24px",
                  }}
                  onClick={() => {
                    setSaveupdate(true);
                    setShow(true);
                    console.log(saveupdate);
                  }}
                >
                  {t("savedata")}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <Form noValidate onSubmit={handleSubmit}>
        <Static_modal
          modalwaiting={modalToggle.modalwait}
          modalErr={modalToggle.modalErr}
          modalSuccess={modalToggle.modalSuccess}
          modalDenied={modalToggle.modalDenied}
          textBody={textBody}
          getHandle={handleClose_Modal}
        />
        <Modal
          show={showError}
          onHide={() => setShowError(false)}
          className="font-cen"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>ข้อผิดพลาด</Modal.Title>
          </Modal.Header>
          <Modal.Body>{ErrorData}</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => setShowError(false)}>
              ปิด
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showSpin}
          onHide={() => setShowError(false)}
          className="font-cen"
          centered
        >
          <Modal.Body>
            <Spinner animation="border" variant="secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Modal.Body>
        </Modal>
        <Modal
          show={updatedata}
          onHide={() => setUpdatedata(false)}
          className="font-cen"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>บันทึกข้อมูล</Modal.Title>
          </Modal.Header>
          <Modal.Body>ข้อมูลส่วนตัวจะถูกบันทึกใหม่</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setUpdatedata(false)}>
              ยกเลิก
            </Button>
            <Button variant="primary" onClick={handleUpdatesuc}>
              ยืนยัน
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={updatedatasuc}
          onHide={handleClose}
          className="font-cen"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>บันทึกข้อมูลสำเร็จ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <img
              alt="22"
              src={check}
              style={{
                width: "100px",
                height: "100px",
                padding: "3%",
                marginLeft: "180px",
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>
        {saveupdate === true ? (
          <Modal
            show={show}
            onHide={() => setShow(false)}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>บันทึกข้อมูลการขอขึ้นทะเบียน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ข้อมูลส่วนตัวจะถูกบันทึกแต่ยังไม่นำส่งข้อมูลขึ้นทะเบียน Drone
              (การบันทึกข้อมูลจะต้องมี หมายเลขซีเรียล,ตราสินค้า / ยี่ห้อ,รุ่น)
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShow(false)}>
                ยกเลิก
              </Button>
              <Button variant="primary" onClick={() => handleSendsuc(true)}>
                บันทึกข้อมูล
              </Button>
            </Modal.Footer>
          </Modal>
        ) : (
          <Modal
            show={show}
            onHide={() => setShow(false)}
            className="font-cen"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ข้อมูลส่วนตัวจะถูกบันทึกใหม่และนำส่งข้อมูลการขอขึ้นทะเบียน Drone
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShow(false)}>
                ยกเลิก
              </Button>
              <Button variant="primary" onClick={() => handleSendsuc(false)}>
                นำส่งข้อมูล
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* <Modal
          show={show}
          onHide={() => setShow(false)}
          className="font-cen"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            ข้อมูลส่วนตัวจะถูกบันทึกใหม่และนำส่งข้อมูลการขอขึ้นทะเบียน Drone
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>
              ยกเลิก
            </Button>
            <Button variant="primary" onClick={()=>handleSendsuc}>
              นำส่งข้อมูล
            </Button>
          </Modal.Footer>
        </Modal> */}
        <Modal
          show={senddata}
          onHide={handleClose}
          className="font-cen"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>นำส่งข้อมูลสำเร็จ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <img
              alt="check"
              src={check}
              style={{
                width: "100px",
                height: "100px",
                padding: "3%",
                marginLeft: "180px",
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              ปิด
            </Button>
            <Button variant="primary" onClick={next}>
              ดูสถานะ
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={checkuserdata}
          centered
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          className="font-cen"
          //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
        >
          <Modal.Body
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "red",
              //background: "black",
            }}
          >
            <h3>
              ท่านยังไม่มีข้อมูลผู้ใช้งาน
              <br />
              <br />
              ระบบกำลังนำทางท่านไป
            </h3>
          </Modal.Body>
        </Modal>
      </Form>
      {/* Test  ^^^^ */}
    </div>
  );
}
export default RegisDrone;
